import { render } from "./NewTubeFormAdminView.vue?vue&type=template&id=35bb7f64"
import script from "./NewTubeFormAdminView.vue?vue&type=script&lang=js"
export * from "./NewTubeFormAdminView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__